import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ProcessEventService } from '@shared/services/process-event.service';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { GetTermsResponse } from './types/GetTermsResponse';
import { PostConsentResponse } from './types/PostConsentResponse';
import { PostConsentRequest } from './types/PostConsentRequest';

@Injectable({
  providedIn: 'root',
})
export class ConsentService {
  private baseUrl = environment.urlOpenBanking;

  constructor(
    private http: HttpClient,
    private processEventService: ProcessEventService
  ) {}

  getTerms(userToken: string): Observable<GetTermsResponse> {
    return new Observable((observer) =>
      this.http
        .get<GetTermsResponse>(`${this.baseUrl}/terms`, {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        })
        .subscribe({
          next: (response) => {
            observer.next(response);
          },
          error: (error) => {
            this.processEventService.push(
              ProcessEventFactory.SpawnInternalErrorEvent({
                errorOrigin: 'ConsentService - getTerms',
                error,
              })
            );
          },
        })
    );
  }

  sendConsent(input: {
    userToken: string;
    userId: string;
    hasConsented: boolean;
    termsVersion: string;
    cguVersion: string;
  }): Observable<unknown> {
    const { userToken, userId, hasConsented, termsVersion, cguVersion } = input;

    const request: PostConsentRequest = {
      consent: hasConsented,
      documentVersions: {
        termsVersion,
        cguVersion,
      },
    };

    return new Observable((observer) =>
      this.http
        .post<PostConsentResponse>(`${this.baseUrl}/users/${userId}/consent`, request, {
          headers: {
            Authorization: `Bearer ${userToken}`,
            Accept: 'application/vnd.oney+json;version=2.0',
          },
        })
        .subscribe({
          next: (response) => {
            observer.next(response);
          },
          error: (error) => {
            this.processEventService.push(
              ProcessEventFactory.SpawnInternalErrorEvent({
                errorOrigin: 'ConsentService - sendConsent',
                error,
              })
            );
          },
        })
    );
  }
}
